import { Component, HostBinding, Input, OnInit, forwardRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { CropDialogComponent, PreloadImgComponent } from '@t-llevo/common-ui';
import { MatIconModule } from '@angular/material/icon';
import {
  ControlValueAccessor,
  NG_VALUE_ACCESSOR,
  ReactiveFormsModule,
} from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 't-llevo-image-input',
  standalone: true,
  imports: [CommonModule, MatIconModule, ReactiveFormsModule, MatButtonModule, PreloadImgComponent],
  templateUrl: './image-input.component.html',
  styleUrl: './image-input.component.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ImageInputComponent),
      multi: true
    }
  ]
})
export class ImageInputComponent implements OnInit, ControlValueAccessor{
  croppedImage: SafeUrl | string | null = null;

  private onChange!: (value: File | null) => void;
  private onTouched!: () => void;

  touched: boolean = false
  value: File | null = null

  @Input() aspectRatio: number = 1 / 1
  @HostBinding('class.error') get error() {
    return this.touched;
  }

  constructor(
    public dialog: MatDialog,
    private sanitizer: DomSanitizer,
    private http: HttpClient,
  ) {}

  writeValue(data: File | null): void {
    this.value = data

    if(data){
      const url = URL.createObjectURL(data)
      this.croppedImage = url
    }
  }
  registerOnChange(fn: (value: File | null) => void): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  ngOnInit(): void {
    if(this.value){
      const url = URL.createObjectURL(this.value)
      this.croppedImage = url
    }
  }

  fileInputChange(event: Event) {
    event.preventDefault()
    const dialog = this.dialog.open(CropDialogComponent, {
      data: {
        dialogTitle: 'Editar Imagen',
        event: event,
        aspectRatio: this.aspectRatio
      },
    });

    dialog.afterClosed().subscribe((data) => {
      if (data) {
        this.croppedImage = this.sanitizer.bypassSecurityTrustUrl(
          data.imgView as string
        );
        this.onChange(data.img)
      } else {
        this.croppedImage = null;
        this.onChange(null);
      }
    });
  }

  deleteImage() {
    this.croppedImage = null;
    this.onChange(null);
  }

  loadImage(url: string) {
    this.croppedImage = this.sanitizer.bypassSecurityTrustUrl(url);
    this.http.get(url, {
      responseType: "blob"
    })
    .subscribe(data => {
      const splitedUrl = url.split('/')
      const fileName = splitedUrl[splitedUrl.length - 1]
      const file = new File([data], fileName)
      this.onChange(file)
    })
  }

  getUrlAsString(){
    return this.croppedImage as string
  }

  markAsTouched(){
    this.onTouched()
  }
}
